import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ComboTurma } from '../../../core/combo-turma';
import { TurmasService } from '../../../services/turmas/turmas.service';


@Component({
    selector: 'combo-turma',
    templateUrl: './combo-turma.component.html',
    styleUrls: ['./combo-turma.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboTurmaComponent implements OnInit {

    @ViewChild('comboTurma', {static: false}) comboTurma: any;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado = false;
    @Input() label = "Turma";

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private turmaService: TurmasService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.turmaService.getAllCombo().subscribe((combos: ComboTurma[]) => {
                this.dados = combos;
                console.log('combos = ', this.dados);
                this.preencherCombo();
            });
        }, 0);

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }

}